import axios from "axios";

const instance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    const token = await sessionStorage.getItem("ACCESS_TOKEN");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default instance;
